// Translations
import form from '../sections/form/translations/ua'

// Translation: Register > Landing (Ukrainian)
export default Object.freeze({
	sections: { form }
})
